import {
    Zap,
    ShoppingCart,
    Lightbulb,
    Building2,
    BookOpen,
    Newspaper
} from "lucide-react";

export const POST_CATEGORIES = [
    {
        id: 'A',
        label: 'Introduction',
        icon: Building2,
        colorClass: 'bg-[#E8EFF7] text-[#15304a]',
        badgeColor: 'bg-[#E8EFF7] text-[#15304a] border border-[#15304a]',
        titleTpl: 'e.g. About {company} — Precision CNC Components for Aerospace & Auto OEMs',
        detailsTpl: 'e.g. {company} is an Ahmedabad-based precision engineering firm with 28 years of experience. We specialize in CNC components for automotive OEMs. Open to new partnerships.'
    },
    {
        id: 'B',
        label: 'Promotion',
        icon: Zap,
        colorClass: 'bg-sahi-yellow-light text-sahi-orange',
        badgeColor: 'bg-sahi-yellow-light text-sahi-orange border border-sahi-orange',
        titleTpl: 'e.g. {company} is Offering 20% Off on Bulk Lubricant Orders This Month',
        detailsTpl: 'e.g. {company} is offering up to 20% off on bulk orders placed before month-end. Ideal for manufacturers looking to stock up at reduced costs.'
    },
    {
        id: 'C',
        label: 'Requirement',
        icon: ShoppingCart,
        colorClass: 'bg-sahi-green-light text-sahi-green',
        badgeColor: 'bg-sahi-green-light text-sahi-green border border-sahi-green',
        titleTpl: 'e.g. {company} Needs High-Grade Aluminum Sheets for Q3 Production',
        detailsTpl: 'e.g. {company} is sourcing Grade 6061-T6 aluminum sheets. We need consistent quality, reliable delivery, and GST-registered suppliers.'
    },
    {
        id: 'E',
        label: 'News',
        icon: Newspaper,
        themeColor: '#bf5700',
        colorClass: 'bg-[#bf570014] text-[#bf5700]',
        badgeColor: 'bg-[#bf570014] text-[#bf5700] border border-[#bf5700]',
        titleTpl: 'e.g. {company} Announces Major Facility Expansion in Sanand Industrial Zone',
        detailsTpl: 'e.g. We are proud to share that {company} has inaugurated a new 25,000 sq ft production unit, expanding our manufacturing capacity to meet growing domestic and export demands.'
    }
];

// Helper to get category by ID quickly
export const POST_CATEGORY_MAP = POST_CATEGORIES.reduce((acc, cat) => {
    acc[cat.id] = cat;
    return acc;
}, {});

// Flexible resolver supporting letters ('A'-'E'), numbers (1-5), or names
export const getCategoryById = (id) => {
    if (!id && id !== 0) return POST_CATEGORIES[0];
    const key = String(id).trim().toUpperCase();
    if (POST_CATEGORY_MAP[key]) return POST_CATEGORY_MAP[key];

    // Aliases
    if (key === '1' || key === 'INTRO' || key === 'INTRODUCTION') return POST_CATEGORY_MAP['A'];
    if (key === '2' || key === 'PROMO' || key === 'PROMOTION') return POST_CATEGORY_MAP['B'];
    if (key === '3' || key === 'REQUIREMENT' || key === 'REQUIREMENTS') return POST_CATEGORY_MAP['C'];
    if (key === '4' || key === 'ADVICE') return POST_CATEGORY_MAP['D'];
    if (key === '5' || key === 'NEWS') return POST_CATEGORY_MAP['E'];

    const found = POST_CATEGORIES.find(
        (c) => c.label.toUpperCase() === key || c.id.toUpperCase() === key
    );
    if (found) return found;

    return {
        id: 'GEN',
        label: 'General',
        icon: BookOpen,
        colorClass: 'bg-zinc-100 text-zinc-700',
        badgeColor: 'bg-zinc-100 text-zinc-700 border border-zinc-200',
        titleTpl: 'Sharing an update from {company}',
        detailsTpl: 'Business update from {company} for the community.'
    };
};
